import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {WinConfig, WinConfigUtil} from "../../../utils/WinConfigUtil";
import {BS2} from "../../../BS2";
import {BS2GameMode} from "../../../server/BS2GameMode";
import {RestoreUtils} from "../../../utils/RestoreUtils";
import {BS2Sound} from "../../../config/sound/BS2Sound";
import {BS2WinView} from "../../../view/BS2WinView";


/**
 * Created by jonas on 2022-01-12.
 */

export class BrokeBankPresentation implements SimplePresentation {

    name:string = "BrokeBankPresentation";

    constructor() {}



    shouldRun():boolean {
        return BS2.model.gameData.brokeTheBank;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            BS2.keypadPlugin.setZeroBetSpinCounter(-1);
            BS2.soundPlayer.fadeOutMusic(300);
            BS2.soundPlayer.playSound(BS2Sound.BROKE_BANK_COUNTUP);
        });

        const countUpDuration = 11.333;
        tl.add(BS2.winView.getBrokeBankStart());
        tl.add(BS2.winView.getWinCountUp(0, BS2.model.gameData.accumulatedRoundWin, countUpDuration, 0, new PIXI.Point(360, 580), true, false),"<");
        tl.add(BS2.winView.getCountUpScaleAnimation(0, BS2.model.gameData.accumulatedRoundWin, countUpDuration, 0.6, 0.8), "<");


        const endAndMoveCountToCenterTl = gsap.timeline();
        endAndMoveCountToCenterTl.add(()=>{
            //BS2.soundPlayer.stopSound(BS2Sound.BROKE_BANK_COUNTUP);
            BS2.soundPlayer.playLoopingSound(BS2Sound.BROKE_BANK_LOOP);
            BS2.keypadPlugin.setWin(BS2.model.gameData.accumulatedRoundWin, true, BS2.isWinBelowStake());
        })
        endAndMoveCountToCenterTl.add(BS2.winView.getPositionAnimation(1, new PIXI.Point(360,370), "power2.out"));
        endAndMoveCountToCenterTl.add(BS2.winView.getCountUpScaleAnimation(BS2.model.gameData.accumulatedRoundWin, BS2.model.gameData.accumulatedRoundWin, 1, 0.8, 1), "<");

        const showButtonTime = tl.totalDuration();

        tl.add(endAndMoveCountToCenterTl, showButtonTime);
        tl.add(BS2.transitionScreen.showMaxWin(), showButtonTime)
        tl.add(BS2.transitionScreen.enableButton(() => this.onButtonClick(controller)), showButtonTime);


     }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        if(!BS2.model.gameData?.enhancedBet){
            RestoreUtils.restoreAfterMaxWin(BS2.model.nextSpinMode());
        }

        const tl:gsap.core.Timeline = gsap.timeline();
        const stayDuration = 0;


        const endSound = BS2Sound.BROKE_BANK_END;
        if (endSound) {
            tl.add(() => BS2.soundPlayer.stopSound(BS2Sound.BROKE_BANK_LOOP));
            tl.add(() => BS2.soundPlayer.stopWinSound());
            tl.add(() => BS2.soundPlayer.playSound(endSound));
        }

        tl.add([
            BS2.winView.getBrokeBankEnd(),
            BS2.winView.getWinCountUpEnd(BS2.model.winData.accumulatedWin, stayDuration, 0),
            () => BS2.soundPlayer.switchMusic(BS2.model.data.nextMode),
            () => BS2.soundPlayer.fadeInMusic(1000)
        ]);


        tl.add(() => {
            BS2.winView.getWinCountUpFade(BS2.model.winData.accumulatedWin, 1);
        });



        tl.add(() => {
            BS2.keypadPlugin.setZeroBetSpinCounter(-1);
        });

        tl.add(BS2.transitionScreen.hideMaxWin());

        tl.add(() => controller.finish());

    }

    private getBigWinLevel(bigWinConfig:WinConfig, duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(gsap.to(this,{duration:duration}));
        if (bigWinConfig.anim) {
            tl.add(() => {
                BS2.winView.getBigWinAnimation(bigWinConfig.anim!, bigWinConfig.particleLevel,duration)
            }, 0);
        }

        return tl;
    }


}